<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Crear pedido
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							v-on="on"
							elevation="5"
							v-bind="attrs"
							color="default"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>

					<v-list>
						<template>
							<v-list-item @click="salesorderImport()">
								<v-list-item-title>
									Importar desde CSV
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center">
				<v-col cols="12" md="10">
					<v-card
						outlined
						:class="[
							'pt-0',
							$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4',
						]"
					>
						<v-card-text
							:class="[{ 'pa-1': $vuetify.breakpoint.smAndDown }]"
						>
							<v-container fluid>
								<CreateUpdate
									:salesorder="salesorder"
									:type="'create'"
									@cancel="cancel"
									@created="created"
								>
								</CreateUpdate>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/main";
import CreateUpdate from "@/components/SalesOrder/CreateUpdate";
import TilteParallax from "@/components/TilteParallax";

export default {
	name: "Create",

	components: { TilteParallax, CreateUpdate },

	data() {
		return {
			session: null,

			salesorder: {},
		};
	},

	created() {
		this.session = JSON.parse(localStorage.getItem("session"));

		this.$store.dispatch("getCustomers");

		let salesorder = JSON.parse(localStorage.getItem("salesorder"));

		if (salesorder) {
			this.salesorder = salesorder;
		} else {
			this.salesorder = {
				note: null,
				articles: [],
				status_id: 2,
				discount: 0,
				customer: null,
				shipping_method_id: null,
				user_id: this.$store.state.acount.user.id,
			};
		}
	},

	methods: {
		back() {
			alert("Tu pedido se guardará y podrás continuar después.");

			this.$router.go(-1);
		},

		created(salesOrder) {
			EventBus.$emit("Snackbar", {
				text: `¡Pedido creado correctamente #${salesOrder.id}!`,
				type: "success",
				timeout: 4000,
			});

			localStorage.removeItem("salesorder");

			this.$router.go(-1);
		},

		cancel() {
			if (confirm("¿Quiere cancelar el pedido actual?")) {
				localStorage.removeItem("salesorder");

				this.$router.go(-1);
			}
		},

		salesorderImport() {
			if (!this.salesorder.customer_id) {
				return EventBus.$emit("Error", {
					error: "¡Atención!",
					message:
						"Para poder continuar, primero seleccione un cliente.",
					alertShow: true,
				});
			}

			EventBus.$emit("SalesorderImport");
		},
	},

	computed: {},
};
</script>

<style lang="css" scoped></style>
